import { makeGetRequest } from 'owa-ows-gateway';
import getTimeProfileRestEndpoint from '../utils/getTimeProfileRestEndpoint';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import TimeProfileInformation from '../data/schema/TimeProfileInformation';
import { createRestApiRequestHeadersWithFetchOptions } from 'owa-headers';

export default async function getTimeProfileService(): Promise<TimeProfileInformation> {
    const response = await makeGetRequest(
        getTimeProfileRestEndpoint('gettimeprofile'),
        undefined /* correlationId */,
        true /* returnFullResponse */,
        createRestApiRequestHeadersWithFetchOptions() /* customheaders */
    );

    if (isSuccessStatusCode(response.status)) {
        return await response.json();
    }

    return null;
}
